// test71
(71 && 0);
